export default __webpack_public_path__ + "static/media/bathroom1-after-1440w.5ab47438.png";